import { ACTIONS, ENVIRONMENT } from '../constants';
import packageConfig from '../utils/packageConfig.json';
import getEnvVariable from '../utils/environment';

const parsePackages = (result) => {
  const pkgs = [];
  if (!result) return [];
  for (let i = 0; i < result.length; i++) {
    const packageObj = result[i];
    if (!(packageObj.id in packageConfig.hiddenPackages)) {
      packageObj.dataRole = `package-${packageObj.name.replace(/\s+/g, '-').toLowerCase()}`;
      pkgs.push(packageObj);
    }
  }
  pkgs.sort((a, b) => a.base_price - b.base_price);
  return pkgs;
};

export const setPackage = activePackage => ({ type: ACTIONS.SET_PACKAGE, activePackage });

const loadPackages = (initialPackageID, packageGroup = 'default') => (dispatch) => {
  const makoAPIURL = `${getEnvVariable(ENVIRONMENT.MAKO_URL)}/v3/public/packages/${packageGroup}`;
  return fetch(makoAPIURL).then(resp => resp.json())
    .then((resp) => {
      const { result } = resp;
      const availablePackages = parsePackages(result);
      dispatch({ type: ACTIONS.LOAD_PACKAGES, availablePackages });
      if (initialPackageID) {
        dispatch({ type: ACTIONS.SET_PACKAGE, activePackage: { id: initialPackageID } });
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

export const initializePackages = (parsedQueryString) => {
  if (parsedQueryString.id) {
    return loadPackages(parsedQueryString.id, parsedQueryString.group);
  } if (!parsedQueryString.aws) {
    return loadPackages();
  }
  const awsPackage = {
    ...packageConfig.awsPackages[parsedQueryString.aws],
    cuuid: parsedQueryString.cuuid,
  };
  return setPackage(awsPackage);
};




// WEBPACK FOOTER //
// ./src/actions/packages.js